// ModalContext.js
import React, { createContext, useState, useContext } from "react"

const ModalContext = createContext()

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeTab, setActiveTab] = useState("login")

  const openModal = tab => {
    setActiveTab(tab)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <ModalContext.Provider
      value={{ isModalOpen, openModal, closeModal, activeTab, setActiveTab }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => useContext(ModalContext)
